import React from 'react';
import * as core from 'cw-ui-core';
import { ADD_ENTITLEMENT_DIALOG_KEY } from 'src/components/Partner/AddEntitlementDialog';
import { ENTITLEMENT_ASSIGNMENT_CONFIRM_DIALOG_KEY } from 'src/components/Partner/EntitlementAssignmentConfirmDialog';
import { SWAP_ENTITLEMENT_DIALOG_KEY } from 'src/components/Partner/SwapEntitlementDialog';
import {
    PRODUCT_INSTANCE_METADATA_UPDATE_DIALOG_KEY,
    REQUEST_FOR_DELETION_DIALOG_KEY,
    UNLOCK_PLATFORM_INSTANCE_DIALOG_KEY,
    PACKAGE_UPGRADE_DIALOG_KEY,
} from 'src/Constants/Constants';
import { USER_ROLE_FILTER_DIALOG_KEY } from 'src/services/userRoleFilterActions';

const componentLoader = path => async callback => callback(await import('./' + path));

const getDialog = (dialogID, props = null) => {
    switch (dialogID) {
        case 'confirm_dialog':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/ConfirmDialog/ConfirmDialogContainer')}
                />
            );
        case 'confirm_dialog_swapped_btn_style':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/ConfirmDialog/ConfirmDialogSwappedBtnStyleContainer')}
                />
            );
        case 'retry_provision_dialog':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/RetryProvisionDialog/RetryProvisionDialogContainer')}
                />
            );
        case 'retry_dialog_swapped_btn_style':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/RetryProvisionDialog/RetryProvisionDialogSwappedBtnStyleContainer')}
                />
            );
        case 'add_product_dialog':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Product/AddProductContainer')}
                />
            );
        case 'edit_credit_card_dialog':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/CreditCard/EditCreditCardContainer')}
                />
            );
        case 'product_instance_details_dialog':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/ProductInstance/ProductInstanceDetailsDialogContainer')}
                />
            );
        case 'remote_support_dialog':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Support/RemoteSupportDialogContainer')}
                />
            );
        case 'reassign_user_dialog':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/User/ReassignUserDialogContainer')}
                />
            );
        case 'reassign_product_instance_dialog':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/ProductInstance/ReassignProductInstanceDialogContainer')}
                />
            );
        case REQUEST_FOR_DELETION_DIALOG_KEY:
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/ProductInstance/RequestForDeletionDialogContainer')}
                />
            );
        case UNLOCK_PLATFORM_INSTANCE_DIALOG_KEY:
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/ProductInstance/UnlockPlatformInstanceDialogContainer')}
                />
            );
        case PRODUCT_INSTANCE_METADATA_UPDATE_DIALOG_KEY:
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/ProductInstance/ProductInstanceMetadataUpdateDialogContainer')}
                />
            );
        case 'reassign_client_dialog':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Client/ReassignClientDialogContainer')}
                />
            );
        case 'client_detail_assign_aditional_user':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Client/AssignAdditionalUserDialogContainer')}
                />
            );
        case ADD_ENTITLEMENT_DIALOG_KEY:
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Partner/AddEntitlementDialogContainer')}
                />
            );
        case ENTITLEMENT_ASSIGNMENT_CONFIRM_DIALOG_KEY:
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Partner/EntitlementAssignmentConfirmDialogContainer')}
                />
            );
        case SWAP_ENTITLEMENT_DIALOG_KEY:
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Partner/SwapEntitlementDialogContainer')}
                />
            );
        case 'add_package_dialog':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Product/Package/AddPackageContainer')}
                />
            );
        case 'import_package_dialog':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Product/Package/ImportPackageDialogContainer')}
                />
            );
        case 'on_create_product':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Product/Entitlements/FormPopup/CreateProductContainer')}
                />
            );
        case 'on_create_feature':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Product/Entitlements/FormPopup/CreateFeatureContainer')}
                />
            );
        case 'on_map_feature_to_product':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Product/Entitlements/FormPopup/MapFeatureToProductContainer')}
                />
            );
        case 'on_bulk_map_features_to_products':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Product/Entitlements/FormPopup/BulkMapFeauturesToProductsContainer')}
                />
            );
        case 'on_audit_logs':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Product/Entitlements/EntitlementManagementTable/EntitlementAuditLogs/EntitlementAuditLogsContainer')}
                />
            );
        case 'on_update_product':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Product/Entitlements/FormPopup/EditProductContainer')}
                />
            );
            case 'on_update_feature':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Product/Entitlements/FormPopup/EditFeatureContainer')}
                />
            );
        case 'create_vendor_account':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Partner/VendorAccount/CreateVendorAccountContainer')}
                />
            );
        case PACKAGE_UPGRADE_DIALOG_KEY:
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/PackageInstances/PackageUpgradeDialogContainer')}
                />
            );
        case 'on_add_entitlement_restriction':
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/Product/Entitlements/AddEntitlementRestrictionContainer')}
                />
            );
        case USER_ROLE_FILTER_DIALOG_KEY:
            return (
                <core.AsyncComponent
                    key={dialogID}
                    {...props}
                    loader={componentLoader('components/User/UserRoleFilter/UserRoleFilterDialogContainer')}
                />
            );
        default:
            return core.getCoreDialog(dialogID, props);
    }
};

export default getDialog;
